module.exports = __webpack_public_path__ + "static/media/logo.96981abd.png";